import axios from "axios";
import Swal from "sweetalert2";

// Lógica compartida para iniciar (o reintentar) la verificación de identidad vía Didit.
// Usada desde Mi cuenta (vendedor/comprador), el Home de vendedor y el modal de publicar.
// idServicio (opcional): si se manda, el backend lo deja pendiente para publicarlo
// solo apenas Didit apruebe (ver /webhook-verificacion-didit), sin depender de que
// el usuario vuelva a ver ninguna pantalla.
export async function iniciarVerificacionIdentidad(usuario, setCargando, idServicio) {
  try {
    if (setCargando) setCargando(true);

    // 1) Validar que tenga al menos un servicio en borrador
    const obtenerServicio = await axios.post("/obtener-servicios", {
      params: { usuario, cualServicio: "Borrador", page: 1, limit: 4 },
    });

    const servicios = obtenerServicio?.data?.servicios || [];

    if (servicios.length < 1) {
      return Swal.fire({ icon: 'error', title: 'Sin servicios', text: 'Aún no has iniciado a crear un servicio. Por favor inicia un servicio antes de verificar tu identidad.', customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar' } });
    }

    // 2) Crear sesión en Didit — mandamos "a dónde volver" para que el propio
    // backend lo incluya en la URL de callback (no depende de sessionStorage,
    // que puede no sobrevivir el viaje de ida y vuelta por Didit en móvil).
    // Si la verificación estaba atada a un servicio puntual, NO volvemos al
    // editor (podría auto-publicarse por el webhook antes de que el usuario
    // regrese, y el editor no sabría que el servicio ya no está en Borrador).
    // En ese caso mandamos al home según el rol actual del usuario (nunca
    // asumimos que es vendedor solo porque venía de publicar un servicio).
    const destinoBase = usuario?.modo === "Vendedor" ? "/vendedor" : "/usuario/mi-cuenta";
    const returnTo = idServicio ? destinoBase : window.location.pathname;
    const resSesion = await axios.post("/crear-sesion-didit", {
      params: { idUsuario: usuario.idUsuario, plataforma: "web", returnTo, idServicio: idServicio || "" }
    });

    const url = resSesion?.data?.url;

    if (!url) { throw new Error("No se recibió URL de verificación"); }

    // Fallback por si acaso; la fuente de verdad es el query param de la URL.
    try { sessionStorage.setItem("hpm_volverA", returnTo); } catch (e) {}

    // 3) Redirigir al flujo de verificación
    window.location.href = url;

  } catch (err) {
    console.log("Error en verificación:", err);
    Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo iniciar la verificación. Intenta nuevamente.', customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar' } });
  }
  finally {
    if (setCargando) setCargando(false);
  }
}
